module.exports = __webpack_public_path__ + "static/media/Southgrove Wall units.82265ca5.JPG";